"use client";

import { PropsWithChildren } from "react";

import { QueryClientProvider } from "@tanstack/react-query";

import { getQueryClient } from "./query-client";

/**
 * Provides the browser QueryClient to the React tree. It holds only
 * the client instance, so it never re-renders consumers with stale server state.
 */
export const QueryProvider = ({ children }: PropsWithChildren) => {
  const queryClient = getQueryClient();

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
